export default __webpack_public_path__ + "static/greeting-cf4b2bb0150fd8720ebafcd8196eff00.svg";